import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Modal from "../../../Components/Modal";

const DesignStudioModel = ({ show, userId, orderId, onClose }) => {
  const Navigate = useNavigate();
  const [designs, setDesigns] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const BASE_IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

  // ✅ Fetch designs based on orderId
  useEffect(() => {
    if (!show || !orderId) return;

    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/graphic_designer/order/products/design`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (res?.data?.success && Array.isArray(res.data.data)) {
          const filtered = res.data.data.filter(
            (item) => Number(item.order_id) === Number(orderId)
          );

          if (filtered.length > 0) {
            setDesigns(filtered);
            setSelectedIndex(0);
          } else {
            setDesigns([]);
            toast.error("No designs found for this order.");
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching designs:", err);
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        } else {
          toast.error("Failed to fetch designs.");
        }
      })
      .finally(() => setLoading(false));
  }, [orderId, show]);

  return (
    <Modal
      open={!!show}
      onClose={onClose}
      title="Design Studio"
      subtitle={
        loading
          ? "Loading designs…"
          : designs.length > 0
          ? `Design ${selectedIndex + 1} of ${designs.length}`
          : "No designs uploaded yet"
      }
      size="lg"
    >
      {loading ? (
        <div className="al-empty" style={{ padding: "32px 20px" }}>
          <p className="al-empty__text">Loading designs…</p>
        </div>
      ) : designs.length === 0 ? (
        <div className="al-empty" style={{ padding: "32px 20px" }}>
          <p className="al-empty__title">No designs found</p>
          <p className="al-empty__text">
            Mockups uploaded for this order will appear here.
          </p>
        </div>
      ) : (
        <>
          <div className="al-stage">
            <img
              src={`${BASE_IMAGE_URL}${designs[selectedIndex]?.design_url}`}
              alt="Selected design"
            />
          </div>

          <div className="al-picker">
            {designs.map((d, index) => (
              <button
                key={index}
                type="button"
                className={`al-picker__i ${
                  index === selectedIndex ? "is-active" : ""
                }`}
                onClick={() => setSelectedIndex(index)}
                title={`Design ${index + 1}`}
              >
                <img
                  src={`${BASE_IMAGE_URL}${d.design_url}`}
                  alt={`Design ${index + 1}`}
                />
              </button>
            ))}
          </div>
        </>
      )}
    </Modal>
  );
};

export default DesignStudioModel;
